export const ROUND_TYPES = {
  GENERAL_ROUNDS: "General Rounds",
  ROUND_OF_32: "Elimination Rounds: Round of 32",
  ROUND_OF_16: "Elimination Rounds: Round of 16",
  QUARTERFINALS: "Elimination Rounds: Quarter-Finals",
  SEMIFINALS: "Elimination Rounds: Semi-Finals",
  FINALS: "Finals",
  CHAMPION: "Champion",
};
